import RemotasksExternalLink from 'react-scale/corp/components/UI/RemotasksExternalLink';
import { SubtaskAssignment } from './types';
import { makeStyles } from 'design-system';

/*
Creating new interface for Sfu tasks Speed Audit. The goal is to make it easier for auditors to audit tasks in Sfu Pipelines.

To allow the quickest path to integration, we have decided to use the existent subtaskAssignment object to pass the information needed to create the links.

Unfortunately, this creates a disconnect between value and name which we have to conceptually remap:
-subtaskAssignment does not correspond to a subtask
-subtaskAssignment.subtask._id corresponds to a HUMAN TASKER NODE ID rather than a subtask

We performed this to integrate this code with minimal friction. In the future, however, Speed Audit as a whole should probably be refactored to support pipelines on v3
with no subtask concept.
*/
const SfuSpeedAuditLinks = (props: { subtaskAssignment: SubtaskAssignment }) => {
  const styles = useSpeedAuditDialogStyles();
  const { subtaskAssignment } = props;
  return (
    <div className={styles.lidarLiteLinkContainer}>
      <div>
        Audit tasks in Lidar lite. Once you are done, come back to this page and grade the task
        here.
      </div>
      <RemotasksExternalLink
        path="/lidarlite"
        query={{ sceneId: subtaskAssignment.subtask._id, readOnly: 1 }}
      >
        View as Tasker (read-only)
      </RemotasksExternalLink>
    </div>
  );
};

const useSpeedAuditDialogStyles = makeStyles(() => ({
  lidarLiteLinkContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 8,
    marginBottom: 8,
  },
}));

export default SfuSpeedAuditLinks;
